import React, { useState } from "react";
import API_URL from "../config";
import "../styles/Formularios.css";
import { useGlobal } from "../context/ContenedorGlobal";
import InputGenerico from "./InputGenerico";

function RecuperarContrasena() {

    const { setModuloActual, setSubModuloActual } = useGlobal();
    const [idTecnico, setIdTecnico] = useState("");
    const [codigoTemp, setCodigoTemp] = useState("");
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");


    const validarInputs = () => {
        if (!/^\d{7}$/.test(idTecnico)) {
            return "El número de empleado debe contener exactamente 7 dígitos.";
        }
        if (!/^[A-Z0-9]{6}$/.test(codigoTemp)) {
            return "El código temporal debe contener exactamente 6 caracteres alfanuméricos (A-Z, 0-9).";
        }
        return null;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccessMessage("");

        const err = validarInputs();
        if (err) {
            setError(err);
            return;
        }

        try {
            const response = await fetch(`${API_URL}/recuperar_contrasena.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id_tecnico: idTecnico,
                    codigo_temp: codigoTemp.toUpperCase(), // Asegura mayúsculas al enviar
                }),
            });

            const data = await response.json();

            if (data.status === "ok") {
                setSuccessMessage("Se envió un enlace de restablecimiento a su correo institucional.");
                setTimeout(() => {
                    setModuloActual("Autenticación");
                    setSubModuloActual(null);
                }, 3000);
            } else {
                setError(data.message || "Error al procesar la solicitud.");
            }
        } catch (err) {
            setError("Error de conexión con el servidor.");
        }
    };

    return (
        <div className="sesion-form">
            <>
                {error && <div className="error">{error}</div>}
            </>

            {successMessage && (
                <div className="success">
                    <p>{successMessage}</p>
                </div>
            )}

            {!successMessage && (
                <form onSubmit={handleSubmit}>

                    <InputGenerico
                        value={idTecnico}
                        setValue={setIdTecnico}
                        label="Número de empleado"
                        maxLength={7}
                        allowedChars="0-9"
                        placeholder="7120000"
                        title="Debe contener exactamente 7 dígitos numéricos"
                    />

                    <InputGenerico
                        value={codigoTemp}
                        setValue={setCodigoTemp}
                        label="Código de recuperación"
                        maxLength={6}
                        allowedChars="0-9A-Z"
                        transform="uppercase"
                        placeholder="A1B2C3"
                        title="Introduzca el código proporcionado por el administrador"
                    />

                    <div className="form-buttons">
                        <button type="submit">Recuperar contraseña</button>
                    </div>
                </form>
            )}

        </div>
    );
}

export default RecuperarContrasena;